import type { IConfigInterface } from "./IConfigInterface.js";

export class Config {
    static CacheAssets: IConfigInterface["CacheAssets"];
    static ConnectedUser: IConfigInterface["ConnectedUser"];
    static Environment: IConfigInterface["Environment"];
    static UseServiceWorker: IConfigInterface["UseServiceWorker"];
    
    // ajoute ici les autres champs de IConfigInterface que tu utilises…

    public static Set = (cfg: IConfigInterface): void => {
        Object.assign(Config, cfg);
    };
}